import { UnauthorizedException } from '@domain/constant/UnauthorizedException';
import { ContentRouteUtil } from '@utils/routeUtil';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type AsyncFunction = (...args: any) => Promise<unknown>;

export default function request<T extends AsyncFunction>(
  constructor: Object,
  key: string,
  descriptor: TypedPropertyDescriptor<T>,
): TypedPropertyDescriptor<T> | undefined {
  const method = descriptor.value as AsyncFunction;

  const overrideMethod = async function (this: unknown, ...args: unknown[]) {
    try {
      return await method.apply(this, args);
    } catch (e: unknown) {
      // TODO: 추후에 sentry 로깅 연동 필요
      console.error(e);
      const result = await checkAuth(e, method, this, args);

      // 공통 처리되는 에러 아닌 경우 다시 throw
      if (!result) throw e;
    }
  };

  descriptor.value = overrideMethod as T;
  return descriptor;
}

const checkAuth = async (e: unknown, method: AsyncFunction, boundThis: unknown, args: unknown[]): Promise<boolean> => {
  if (e instanceof UnauthorizedException) {
    // TODO: view에서 컨트롤하는 게 더 좋아보임. 추후 개선 필요.
    ContentRouteUtil.goLoginPage();
    return true;
  }

  return false;
};
